export enum TransitOperator {
  A_SHIPS_MANAGEMENT = 'A Ships Management',
  ARDIA_FERRIES = 'Adria Ferries',
  AEROE_FERRIES = 'Aeroe Ferries',
  AFRICA_MOROCCO_LINK = 'Africa Morocco Link',
  ANEK_SUPERFAST_FERRIES = 'ANEK Superfast Ferries',
  BALEARIA = 'Balearia',
  BLUE_STAR_FERRIES = 'Blue Star Ferries',
  BLUFERRIES = 'Bluferries',
  BORNHOLMSLINJEN = 'Bornholmslinjen',
  BRITTANY_FERRIES = 'Brittany Ferries',
  CALEDONIAN_MACBRAYNE = 'Caledonian MacBrayne',
  CARONTE_TOURIST = 'Caronte & Tourist',
  CLDN_RORO_SEATRUCK_FERRIES = 'CLdN RoRo (Seatruck Ferries)',
  COLONSAY = 'Colonsay',
  COLOR_LINE = 'Color Line',
  CONDOR_FERRIES = 'Condor Ferries',
  CORFU_FERRIES = 'Corfu Ferries',
  CORSICA_FERRIES = 'Corsica Ferries',
  CORSICA_LINEA = 'Corsica Linea',
  CRETA_CARGO_LINES = 'Creta Cargo Lines',
  DESTINATION_GOTLAND = 'Destination Gotland',
  DFDS_JERSEY = 'DFDS Jersey',
  DFDS_LD_LINES = 'DFDS LD Lines',
  DFDS_SEAWAYS_BALTIC_SEA = 'DFDS Seaways (Baltic Sea)',
  DFDS_SEAWAYS_DOVER = 'DFDS Seaways (Dover)',
  DFDS_SEAWAYS_MEDITERRANEAN = 'DFDS Seaways (Mediterranean)',
  DFDS_SEAWAYS_NORTH_SEA = 'DFDS Seaways (North Sea)',
  E60_SHIPPING_LINE = 'E60 Shipping Line',
  ECKERO_LINE = 'Eckero Line',
  FINNLINES = 'Finnlines',
  FJORD_LINE = 'Fjord Line',
  FRS_FERRIES = 'FRS Ferries',
  GRANDI_NAVI_VELOCI = 'Grandi Navi Veloci',
  GRENDI_GROUP = 'Grendi Group',
  GRIMALDI_LINES = 'Grimaldi Lines',
  HELLENIC_SEAWAYS = 'Hellenic Seaways',
  IRISH_FERRIES = 'Irish Ferries',
  ISLE_OF_MAN_STEAM_PACKET = 'Isle of Man Steam Packet',
  JADROLINIJA_LINES = 'Jadrolinija Lines',
  LA_MERIDIONALE = 'La Meridionale',
  LESHUTTLE_EUROTUNNEL_FREIGHT = 'LeShuttle (Eurotunnel) Freight',
  LESHUTTLE_EUROTUNNEL_FREIGHT_VANS_ON_PASSENGER_VP = 'LeShuttle (Eurotunnel) Freight Vans on Passenger (VP)',
  LESHUTTLE_EUROTUNNEL_FREIGHT_VP_FLEXI = 'LeShuttle (Eurotunnel) Freight VP Flexi',
  MINOAN_LINES = 'Minoan Lines',
  MOBY_LINES = 'Moby Lines',
  MOLSLINJEN = 'Molslinjen',
  MONT_BLANC_AND_FREJUS_TUNNELS = 'Mont Blanc and Fréjus Tunnels',
  NAVIBULGAR = 'Navibulgar',
  NAVIERA_ARMAS = 'Naviera Armas',
  NORDOLINK = 'NordoLink (Finnlines)',
  NORTHLINK_FERRIES = 'Northlink Ferries',
  ORESUND_BRIDGE = 'Oresund Bridge',
  PO_DOVER = 'P&O Dover',
  PO_IRISH_SEA = 'P&O Irish Sea',
  PO_NORTH_SEA = 'P&O North Sea',
  PB_MANAGEMENT = 'PB Management',
  POLFERRIES = 'Polferries',
  RALPIN = 'RAlpin',
  RED_FUNNEL_FERRIES = 'Red Funnel Ferries',
  SALAMIS_LINES = 'Salamis Lines',
  SAMSO_REDERI = 'Samso Rederi',
  SBS_SHIPPING = 'SBS Shipping',
  SCANDLINES = 'Scandlines',
  SEA_LINES = 'Sea Lines',
  SEA_CARGO = 'Sea-Cargo',
  SMYRIL_LINES = 'Smyril Lines',
  STENA_LINE = 'Stena Line',
  STOREBAELT = 'Storebaelt',
  SYLT_FERRY = 'Sylt Ferry',
  TALLINK_SILJA_LINE = 'Tallink Silja Line',
  TIRRENIA_LINES = 'Tirrenia Lines',
  TRANSFENNICA = 'Transfennica',
  TRANSMED_GLE = 'Trasmed GLE',
  TT_LINE = 'TT-Line',
  UKRFERRY = 'UKRferry',
  UNITY_LINE = 'Unity Line',
  VENTOURIS_FERRIES = 'Ventouris Ferries',
  VIKING_LINE = 'Viking Line',
  VIRTU_FERRIES = 'Virtu Ferries',
  WASALINE = 'Wasaline',
  WIGHTLINK_FERRIES = 'Wightlink Ferries',
}
